import React, {useEffect, useRef} from 'react';
import {inject, observer} from 'mobx-react';
import {CurrentTimeStore} from 'stores/current_time_store';

const FIVE_MINUTES_SEC = 300;
const ONE_MINUTE_SEC = 60;
const TWO_SYMBOLS = 2;

const getTimerClasses = (remainingSeconds: number): string => {
    if (remainingSeconds >= FIVE_MINUTES_SEC) {
        return 'quick-bets-timer quick-bets-timer--green';
    }
    if (remainingSeconds >= ONE_MINUTE_SEC) {
        return 'quick-bets-timer quick-bets-timer--orange';
    }
    return 'quick-bets-timer quick-bets-timer--red quick-bets-timer--pulse';
};

const formatTimer = (seconds: number): string => {
    const mins = Math.floor(seconds / ONE_MINUTE_SEC);
    const secs = seconds % ONE_MINUTE_SEC;

    return `${String(mins).padStart(TWO_SYMBOLS, '0')}:${String(secs).padStart(TWO_SYMBOLS, '0')}`;
};

interface QuickBetsTimerProps {
    lineDate: number;
    currentTimeStore?: CurrentTimeStore;
    onExpired?: () => void;
}

const QuickBetsTimer = (props: QuickBetsTimerProps): React.JSX.Element | null => {
    const {lineDate, currentTimeStore, onExpired} = props;
    const remainingSeconds = lineDate - (currentTimeStore?.t ?? 0);
    const prevRemaining = useRef<number | null>(null);

    useEffect(() => {
        if (prevRemaining.current !== null && prevRemaining.current > 0 && remainingSeconds <= 0) {
            onExpired?.();
        }

        prevRemaining.current = remainingSeconds;
    }, [remainingSeconds, onExpired]);

    if (remainingSeconds <= 0) {
        return null;
    }

    return (
        <span className={getTimerClasses(remainingSeconds)}>
            {formatTimer(remainingSeconds)}
        </span>
    );
};

export default inject('currentTimeStore')(observer(QuickBetsTimer));
